const $j = (typeof window !== 'undefined' && (window as Window & { $j: unknown }).$j) || (() => {}) as (s: string) => unknown;
const loader_delay = ((window as Window & { loader_delay?: number }).loader_delay ?? 200) as number;
const loader_fadeout = ((window as Window & { loader_fadeout?: number }).loader_fadeout ?? 300) as number;
const getRandomInt = (typeof window !== 'undefined' && (window as Window & { getRandomInt?: (a: number, b: number) => number }).getRandomInt) || (() => 300);

const bLazy = new Blazy({
    success(el) {
        setTimeout(() => {
            const parent = el.parentNode as HTMLElement;
            const loader = parent?.querySelector('.img-loader');
            if (typeof loader !== 'undefined' && loader != null && typeof (loader as HTMLElement).parentNode !== 'undefined' && (loader as HTMLElement).parentNode != null) {
                (loader as HTMLElement).style.opacity = '0';
                el.classList.remove('preload');
                setTimeout(() => {
                    if (typeof loader !== 'undefined' && loader != null && typeof (loader as HTMLElement).parentNode !== 'undefined' && (loader as HTMLElement).parentNode != null) {
                        (loader as HTMLElement).parentNode!.removeChild(loader as HTMLElement);
                    }
                }, 750);
            }
        }, getRandomInt(100, 600));
    },
    error(el: HTMLElement, msg: string) {
        if (msg === 'missing' || msg === 'invalid') {
        }
    },
});

export function loader(): void {
    if (!!($j('.main-content') as { length: number }).length) {
        ($j('.main-content') as { fadeTo: (n: number, o: number) => void }).fadeTo(250, 1);
    }
    if (!!($j('div.loader') as { length: number }).length) {
        setTimeout(() => {
            ($j('div.loader') as { fadeOut: (n: number) => void }).fadeOut(loader_fadeout);
        }, loader_delay);
    }
    if (!!($j('.preload') as { length: number }).length) {
        setTimeout(() => {
            ($j('.preload') as { fadeTo: (n: number, o: number) => { removeClass: (c: string) => void } }).fadeTo(300, 1).removeClass('preload');
        }, loader_delay + 100);
    }
    bLazy.revalidate();
    setTimeout(() => bLazy.revalidate(), 7500);
    ($j('.hero.multi') as { css: (o: object) => void }).css({
        height: parseInt(($j('.hero') as { height: () => number }).height(), 10),
        overflow: 'hidden',
    });
}
